import { combineReducers, createFeature } from '@ngrx/store';

import { authSessionReducer } from './auth-session/auth-session.reducer';
import { authSsoReducer } from './auth-sso/auth-sso.reducer';
import { impersonationReducer } from './impersonation/impersonation.reducer';

export const authFeatureKey = 'auth';

export const authReducer = combineReducers({
  session: authSessionReducer,
  sso: authSsoReducer,
  impersonation: impersonationReducer,
});

export const authFeature = createFeature({
  name: authFeatureKey,
  reducer: authReducer,
});
